import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_2 = { class: "card-body pt-10" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "mb-10 text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-3" }, "Cập nhật quyền")
], -1)
const _hoisted_4 = { class: "row fv-row mb-7" }
const _hoisted_5 = { class: "col-xl-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Quyền", -1)
const _hoisted_7 = { class: "fv-plugins-message-container" }
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "col-xl-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Quyền", -1)
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = {
  id: "kt_sign_up_submit",
  ref: "submitButton",
  type: "submit",
  class: "btn btn-lg btn-primary"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Lưu lại ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Đang xử lý... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
        novalidate: "novalidate",
        onSubmit: _ctx.onSubmitForm,
        "validation-schema": _ctx.registration,
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Field, {
              class: "form-control form-control-lg form-control-solid",
              type: "hidden",
              name: "id",
              modelValue: _ctx.PERMISSIONS_DETAIL.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.PERMISSIONS_DETAIL.id) = $event)),
              autocomplete: "off"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "text",
                name: "name",
                modelValue: _ctx.PERMISSIONS_DETAIL.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.PERMISSIONS_DETAIL.name) = $event)),
                autocomplete: "off"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_ErrorMessage, { name: "name" })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_Field, {
                class: "form-control form-control-lg form-control-solid",
                type: "text",
                placeholder: "",
                name: "module",
                autocomplete: "off",
                modelValue: _ctx.PERMISSIONS_DETAIL.module,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.PERMISSIONS_DETAIL.module) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_ErrorMessage, { name: "module" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("button", _hoisted_14, _hoisted_17, 512)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"])
    ])
  ]))
}